import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlSegment} from '@angular/router';
import {APP_BASE_HREF} from '@angular/common';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeModule } from './features/home/home.module';

export function profileRequestingRouteMatcher(url: UrlSegment[]) {
  return url.map(u => u.path).join('/').startsWith('profile-requesting') ? ({consumed: url}) : null;
}

export function serviceOfferRouteMatcher(url: UrlSegment[]) {
  return url.map(u => u.path).join('/').startsWith('service-offer') ? ({consumed: url}) : null;
}

export function serviceBuyerRouteMatcher(url: UrlSegment[]) {
  return url.map(u => u.path).join('/').startsWith('service-buyer') ? ({consumed: url}) : null;
}

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
  },
  {
    matcher: profileRequestingRouteMatcher,
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
  },
  {
    matcher: serviceOfferRouteMatcher,
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
  },
  {
    matcher: serviceBuyerRouteMatcher,
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
  },
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '/404'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload'})],
  providers: [{provide: APP_BASE_HREF, useValue: '/'}],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
